import { Observable } from 'rxjs';
import { startWith, distinctUntilChanged, shareReplay } from 'rxjs/operators';

export function valueStartingWith<TValue>(value: TValue) {
  return (source$: Observable<TValue>) =>
    source$.pipe(startWith(value), distinctUntilChanged(), shareReplay({ bufferSize: 1, refCount: true }));
}
